<template>
  <li
    class="shadow p-3 mb-4 rounded"
    :class="{ 'load load--fill': loading }"
  >
    <div class="flex justify-between">
      <div class="flex flex-col">
        <div>
          <slot />
        </div>
        <div class="mt-2">
          <small
            class="text-xs text-grey-dark"
            v-text="date"
          />
        </div>
      </div>
      <div class="ml-4">
        <span
          v-if="!isRead"
          class="btn btn--sm btn--icon-only btn--border"
          @click.prevent="markRead"
        >
          ✔
        </span>
      </div>
    </div>
    <slot name="actionMessage" />
  </li>
</template>

<script type="text/babel">
export default {
  name: 'NotificationTypeWrapper',
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    date() {
      return this.moment(this.notification.attributes.created_at).fromNow()
    },
    isRead() {
      return !!this.notification.attributes.read_at
    },
  },
  methods: {
    markRead() {
      this.loading = true

      this.$api.active().post(`notifications/${this.notification.id}/read`)
        .then(() => {
          Promise.all([
            this.$store.dispatch('notificationGetNotifications'),
            this.$store.dispatch('notificationGetNotifications', { type: 'read' }),
          ]).then(() => {
            this.loading = false

            this.$store.commit('baseAddNotification', {
              text: 'Notification marked as read!',
              type: 'success',
            })
          })
        })
    },
  },
}
</script>
